import API from './api';

export const timesheetAnalyticsService = {
  // Month-wise timesheet + attendance analytics for the 3 months ending at end_month (YYYY-MM)
  // params: { end_month, employee_id, project_id, include_drafts }
  getReport: (params) => API.get('/timesheet-analytics/report', { params }),
};
